export default function (element, data) {
    window.addEventListener("load", function () {
        const scrollerBlock = element.querySelector(".scroller-block");
        const scrollerChunk = element.querySelector(".scroller-chunk");
        const viewWidth = element.clientWidth;
        const chunkWidth = scrollerChunk.offsetWidth;

        const limitScroller = data.limitScroller;

        if (!limitScroller || chunkWidth > viewWidth * 0.75) {
            /*
            if (chunkWidth < 50 || viewWidth < 1) {
                return;
            }
            */

            const numCopies = Math.ceil((viewWidth - chunkWidth) / chunkWidth);

            if (numCopies > 1000) {
                return;
            }

            for (let i = 0; i < numCopies; i++) {
                const chunkCopy = scrollerChunk.cloneNode(true);
                chunkCopy.classList.add("scroller-chunk-copy");
                scrollerBlock.append(chunkCopy);
            }

            const blockCopy = scrollerBlock.cloneNode(true);
            blockCopy.classList.add("scroller-block-copy");
            element.append(blockCopy);

            const blockWidth = scrollerBlock.offsetWidth;

            // Параметры анимации
            let viewOffset = 0;     // текущее смещение
            let velocity = 0;       // текущая скорость
            let lastTimestamp = 0;  // метка времени для расчета deltaTime
            let isDragging = false; // флаг перетаскивания
            let lastX = 0;          // последняя X-координата указателя
            let startX = 0;         // начальная X-координата при нажатии
            let startTime = 0;      // время начала перетаскивания
            let friction = 0.99;    // коэффициент трения (0-1)
            let baseVelocity = -1;  // базовая скорость для движения справа налево
            let wasDragged = false; // флаг, указывающий на то, было ли перемещение

            // Порог для определения перетаскивания (в пикселях)
            const DRAG_THRESHOLD = 5;
            // Порог для определения времени перетаскивания (в мс)
            const TIME_THRESHOLD = 150;

            // Функция анимации с использованием requestAnimationFrame
            function animate(timestamp) {
                if (!lastTimestamp) lastTimestamp = timestamp;
                const deltaTime = timestamp - lastTimestamp;
                lastTimestamp = timestamp;

                if (!isDragging) {
                    // Применяем трение к скорости, когда нет перетаскивания
                    velocity = (velocity - baseVelocity) * friction + baseVelocity;

                    // Обновляем позицию на основе скорости
                    viewOffset = viewOffset + velocity * (deltaTime / 16); // Нормализуем для ~60fps
                }

                const clampedOffsed = clampOffset(viewOffset, blockWidth);

                // Применяем трансформацию
                scrollerBlock.style.transform = `translateX(${clampedOffsed}px)`;
                blockCopy.style.transform = `translateX(${clampedOffsed}px)`;

                // Продолжаем анимацию
                requestAnimationFrame(animate);
            }

            // Запускаем анимацию
            requestAnimationFrame(animate);

            // Обработчики событий указателя (мышь/палец)
            function handlePointerDown(e) {
                if (wasDragged) {
                    element.classList.remove("dragged");
                    wasDragged = false;
                }
                
                isDragging = true;
                lastX = getPointerX(e);
                startX = e.pageX;
                startTime = Date.now();
                
                e.preventDefault();
            }

            function handlePointerMove(e) {
                if (!isDragging) return;

                const currentX = getPointerX(e);
                const deltaX = currentX - lastX;

                if ((Math.abs(e.pageX - startX) > DRAG_THRESHOLD || Date.now() - startTime > TIME_THRESHOLD) && !wasDragged) {
                    wasDragged = true;
                    element.classList.add("dragged");
                }

                // Обновляем позицию непосредственно во время перетаскивания
                viewOffset += deltaX;

                // Обновляем скорость на основе движения
                velocity = deltaX;

                lastX = currentX;
                
                if (wasDragged) {
                    e.stopPropagation();
                    e.preventDefault();
                }
            }

            function handlePointerUp(e) {
                isDragging = false;
                
                if (wasDragged) {
                    setTimeout(function () {
                        element.classList.remove("dragged");
                        wasDragged = false;
                    }, 50);
                }
            }

            // Вспомогательная функция для получения X-координаты из события
            function getPointerX(e) {
                return e.clientX || (e.touches && e.touches[0] ? e.touches[0].clientX : 0);
            }

            // Добавляем обработчики событий для мыши и касаний
            element.addEventListener("mousedown", handlePointerDown);
            element.addEventListener("touchstart", handlePointerDown, { passive: false });

            window.addEventListener("mousemove", handlePointerMove);
            window.addEventListener("touchmove", handlePointerMove, { passive: false });

            window.addEventListener("mouseup", handlePointerUp);
            window.document.querySelector("body").addEventListener("mouseleave", handlePointerUp);
            window.addEventListener("touchend", handlePointerUp);
            window.addEventListener("touchcancel", handlePointerUp);
        } else {
            element.classList.add("centered-block");
        }
    });
}

function clampOffset(offset, width) {
    return ((offset - width) % width - width) % width;
}
